import React from "react";
import { Row, Col, Typography } from "antd";

const { Text } = Typography;

const TitleText = ({ title, text, rightItem }) => (
  <Row>
    <Col span={6}>
      <Text strong>{title}</Text>
    </Col>
    <Col span={18}>
      <Text strong>{text}</Text>
      {rightItem}
    </Col>
  </Row>
);

export default TitleText;
